import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/sideToggleOption.scss';
export const ButtonToggleOption = ({ children, groupId, checked, className, disabled = false, onChange }) => {
    const disabledClass = disabled ? ' disabled' : '';
    const checkedClass = checked ? ' active' : '';
    const combinedClassName = ['button-toggle-option', checkedClass, disabledClass, className].join(' ');
    return (_jsxs("label", { className: combinedClassName, children: [_jsx("input", { type: "radio", name: groupId, checked: checked, onChange: onChange, disabled: disabled }), children] }));
};
